export const productFr = {
  "Veuillez Ajouter des produits": "Veuillez Ajouter des produits",
  "Titre": "Titre",
  "Qté": "Qté",
  "Donner le titre de votre produit": "Donner le titre de votre produit",
  "Donner Une Note sur votre produit": "Donner Une Note sur votre produit",

  "Rechercher": "Rechercher",
  "Rechercher par titre": "Rechercher par titre",
  "En stock": "En stock",
}